<!-- Loading State -->
@if (loading && data.length === 0) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <span>Carregando...</span>
  </div>
}

<!-- Empty State -->
@if (!loading && data.length === 0) {
  @if (emptyTemplate) {
    <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
  } @else {
    <div class="empty-state">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="64" height="64">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      <h3>{{ emptyMessage }}</h3>
      <p>{{ emptySubMessage }}</p>
    </div>
  }
}

<!-- Modal de configuração de colunas -->
@if (seletorColunasAberto) {
  <div class="column-modal-overlay" role="dialog" aria-modal="true" aria-label="Configurar colunas">
    <div class="column-modal">
      <div class="column-modal-header">
        <div class="column-modal-title">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span>Configurar Colunas</span>
        </div>
        <button class="btn-modal-close" (click)="fecharSeletorColunas()" title="Fechar">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="column-modal-hint">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="14" height="14">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>Arraste para reordenar · Marque para exibir · Configuração salva automaticamente</span>
      </div>
      <div class="column-modal-list">
        @for (col of colunasOrdenadas; track col.field; let i = $index) {
          <div
            class="column-modal-item"
            [class.oculta]="colunaOculta(col.field)"
            [class.drag-over]="dragOverIndex === i"
            draggable="true"
            (dragstart)="onDragStart($event, col.field)"
            (dragover)="onDragOver($event, i)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event, i)"
            (dragend)="onDragEnd()">
            <div class="drag-handle" title="Arrastar">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                <path d="M8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM8 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM16 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM16 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM16 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
              </svg>
            </div>
            <span class="col-position">{{ i + 1 }}</span>
            <label class="column-modal-label" [for]="'col-tp-' + tableId + '-' + col.field">
              <input
                type="checkbox"
                [id]="'col-tp-' + tableId + '-' + col.field"
                [checked]="!colunaOculta(col.field)"
                [disabled]="!colunaOculta(col.field) && totalColunasVisiveis <= 1"
                (change)="toggleColuna(col.field)">
              <span class="col-name">{{ col.header }}</span>
              @if (colunaOculta(col.field)) {
                <span class="col-badge-oculta">Oculta</span>
              }
            </label>
            <div class="column-order-btns">
              <button class="btn-order" (click)="moverColuna(col.field, 'up')" [disabled]="i === 0" title="Mover para cima">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="12" height="12">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
              </button>
              <button class="btn-order" (click)="moverColuna(col.field, 'down')" [disabled]="i === colunasOrdenadas.length - 1" title="Mover para baixo">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="12" height="12">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>
          </div>
        }
      </div>
      <div class="column-modal-footer">
        <span class="col-counter">{{ totalColunasVisiveis }} de {{ colunasOrdenadas.length }} colunas visíveis</span>
        <button class="btn-restaurar" (click)="restaurarPadrao()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="14" height="14">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Restaurar padrão
        </button>
        <button class="btn-confirmar" (click)="fecharSeletorColunas()">Concluído</button>
      </div>
    </div>
  </div>
}

<!-- Tabela -->
@if (data.length > 0) {
  <!-- Barra superior da tabela com botão de colunas -->
  <div class="tabela-toolbar">
    <div class="tabela-toolbar-right">
      <button class="btn-column-selector" (click)="toggleSeletorColunas()" [class.active]="seletorColunasAberto" title="Configurar colunas visíveis">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="15" height="15">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        Colunas
        @if (totalColunasVisiveis < colunasOrdenadas.length) {
          <span class="colunas-badge">{{ totalColunasVisiveis }}/{{ colunasOrdenadas.length }}</span>
        }
      </button>
    </div>
  </div>

  <div class="tabela-container">
    <div class="table-responsive">
      <table class="table-primary">
        <thead>
          <tr>
            @for (column of colunasVisiveis; track column) {
              <th
                [ngStyle]="getColumnStyle(column)"
                [class.sortable]="isSortable(column)"
                [class.sorted]="currentSort?.field === column.field"
                (click)="onHeaderClick(column)">
                <div class="th-content">
                  <span>{{ column.header }}</span>
                  @if (isSortable(column)) {
                    <span class="sort-icon">
                      @if (getSortIcon(column) === 'asc') {
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="14" height="14">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                        </svg>
                      }
                      @if (getSortIcon(column) === 'desc') {
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="14" height="14">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      }
                      @if (getSortIcon(column) === 'none') {
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="14" height="14" class="sort-neutral">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                        </svg>
                      }
                    </span>
                  }
                </div>
              </th>
            }
            @if (actionsTemplate) {
              <th class="actions-column">Ações</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of displayedData; track row) {
            <tr [ngClass]="getRowClass(row)" (click)="onRowClick(row)">
              @for (column of colunasVisiveis; track column) {
                <td [ngStyle]="getColumnStyle(column)" [ngClass]="getCellClass(column)">
                  @if (column.useTemplate && cellTemplate) {
                    <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row, column: column, value: getCellValue(row, column) }"></ng-container>
                  } @else {
                    {{ formatValue(getCellValue(row, column), column) }}
                  }
                </td>
              }
              @if (actionsTemplate) {
                <td class="actions-cell">
                  <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Loading overlay -->
    @if (loading && data.length > 0) {
      <div class="table-loading-overlay">
        <div class="loading-spinner-small"></div>
      </div>
    }
  </div>

  <!-- Rodapé com Paginação -->
  <div class="pagination-footer">
    <!-- Informação de registros -->
    @if (showRecordsInfo) {
      <div class="records-info">
        {{ recordsInfo }}
      </div>
    }

    <!-- Controles de paginação -->
    <div class="pagination-controls">
      <!-- Seletor de tamanho de página -->
      @if (showPageSizeSelector) {
        <div class="page-size-selector">
          <label>Por página:</label>
          <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }}</option>
            }
          </select>
        </div>
      }

      <!-- Navegação de páginas -->
      <div class="page-navigation">
        <!-- Primeira página -->
        <button
          class="btn-page btn-page-nav"
          [disabled]="!canGoPrevious || loading"
          (click)="goToFirstPage()"
          title="Primeira página">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="16" height="16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
        </button>

        <!-- Página anterior -->
        <button
          class="btn-page btn-page-nav"
          [disabled]="!canGoPrevious || loading"
          (click)="goToPreviousPage()"
          title="Página anterior">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="16" height="16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- Números das páginas -->
        <div class="page-numbers">
          @if (pageNumbers[0] > 1) {
            <button
              class="btn-page btn-page-number"
              (click)="goToPage(1)"
              [disabled]="loading">
              1
            </button>
            @if (pageNumbers[0] > 2) {
              <span class="page-ellipsis">...</span>
            }
          }

          @for (page of pageNumbers; track page) {
            <button
              class="btn-page btn-page-number"
              [class.active]="page === currentPage"
              (click)="goToPage(page)"
              [disabled]="loading">
              {{ page }}
            </button>
          }

          @if (pageNumbers[pageNumbers.length - 1] < totalPages) {
            @if (pageNumbers[pageNumbers.length - 1] < totalPages - 1) {
              <span class="page-ellipsis">...</span>
            }
            <button
              class="btn-page btn-page-number"
              (click)="goToPage(totalPages)"
              [disabled]="loading">
              {{ totalPages }}
            </button>
          }
        </div>

        <!-- Próxima página -->
        <button
          class="btn-page btn-page-nav"
          [disabled]="!canGoNext || loading"
          (click)="goToNextPage()"
          title="Próxima página">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="16" height="16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- Última página -->
        <button
          class="btn-page btn-page-nav"
          [disabled]="!canGoNext || loading"
          (click)="goToLastPage()"
          title="Última página">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="16" height="16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <!-- Info da página atual -->
      <div class="page-info">
        Página {{ currentPage }} de {{ totalPages }}
      </div>
    </div>
  </div>
}
